'use client';

import React from 'react';

import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import MobileNavigation from './MobileNavigation';

interface MobileSideDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onRequestCallback: () => void;
  onOpenShoppingWallet?: () => void;
  showShoppingWallet?: boolean;
}

/**
 * Mobile side drawer (hamburger menu).
 * Focuses on browsing navigation (Home, Categories) and Support.
 * Account actions are in the header dropdown.
 */
function MobileSideDrawer({
  open,
  onOpenChange,
  onRequestCallback,
  onOpenShoppingWallet,
  showShoppingWallet = false,
}: MobileSideDrawerProps) {
  const handleClose = () => {
    onOpenChange(false);
  };

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-[300px] overflow-y-auto p-0">
        <SheetHeader className="border-b px-6 py-4">
          <SheetTitle className="text-left text-lg font-semibold">Menu</SheetTitle>
        </SheetHeader>
        <div className="px-3">
          <MobileNavigation
            onClose={handleClose}
            onRequestCallback={onRequestCallback}
            onOpenShoppingWallet={onOpenShoppingWallet}
            showShoppingWallet={showShoppingWallet}
          />
        </div>
      </SheetContent>
    </Sheet>
  );
}

export default MobileSideDrawer;
